import React from "react";
import { Icon } from "@chakra-ui/react";
import {
  MdHome,
  MdPeopleAlt,
  MdCurrencyExchange
} from "react-icons/md";
import Dashboard from "./views/auth/dashboard";
import SignIn from "./views/non-auth/signIn";
import Register from "./views/non-auth/register";
import ForgotPassword from "./views/non-auth/forgot-password";
import ChangePassword from "./views/non-auth/change-password";
import UserList from "views/auth/user";
import OrderHistory from "views/auth/order";
import { Role } from "./common/constant";

/// <summary>
/// Author: -
/// </summary>
export class WebUrl {
  static _DEFAULT = '/';
  static _REGISTER = '/register';
  static _FORGOT_PASSWORD = '/forgot-password';
  static _CHANGE_PASSWORD = '/change-password';
  static _LOGIN = '/login';
  static _USER_LIST = '/user/list';
  static _TRANSACTION = '/transaction';
}

/// <summary>
/// Author: -
/// </summary>
export const _NON_AUTH_ROUTES = [
  {
    name: "SIGN_IN",
    path: WebUrl._DEFAULT,
    component: <SignIn />,
  },
  {
    name: "SIGN_IN",
    path: WebUrl._LOGIN,
    component: <SignIn />,
  },
  {
    name: "REGISTER",
    path: WebUrl._REGISTER,
    component: <Register />,
  },
  {
    name: "FORGOT_PASSWORD",
    path: WebUrl._FORGOT_PASSWORD,
    component: <ForgotPassword />,
  },
  {
    name: "CHANGE_PASSWORD",
    path: WebUrl._CHANGE_PASSWORD,
    component: <ChangePassword />,
  }
]

/// <summary>
/// Author: -
/// Remark: Not declaring role key mean open for all roles | empty array mean hide from all roles
/// </summary>
export const _AUTH_ROUTES = [
  // {
  //   name: "DASHBOARD",
  //   path: WebUrl._DEFAULT,
  //   icon: <Icon as={MdHome} width='22px' height='22px' color='inherit' />,
  //   component: <Dashboard />,
  //   roles: [
  //     Role._SUPERADMIN, Role._ADMIN, Role._MERCHANT
  //   ]
  // },
  {
    name: "TRANSACTION",
    path: WebUrl._DEFAULT,
    icon: <Icon as={MdHome} width='22px' height='22px' color='inherit' />,
    isHidden: true,
    component: <OrderHistory />,
    roles: [
      Role._SUPERADMIN, Role._ADMIN, Role._MERCHANT
    ]
  },
  {
    name: "USER",
    path: WebUrl._USER_LIST,
    icon: <Icon as={MdPeopleAlt} width='22px' height='22px' color='inherit' />,
    component: <UserList />,
    roles: [
      Role._SUPERADMIN, Role._ADMIN
    ]
  },
  {
    name: "TRANSACTION",
    path: WebUrl._TRANSACTION,
    icon: <Icon as={MdCurrencyExchange} width='22px' height='22px' color='inherit' />,
    component: <OrderHistory />,
    roles: [
      Role._SUPERADMIN, Role._ADMIN, Role._MERCHANT
    ]
  }
];